module.exports = __webpack_public_path__ + "static/img/banner_mac.944b082.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_mac.jpeg
// module id = /Up8
// module chunks = 0